import { EntitlementState, useEntitlement, useEntitlementState } from './useEntitlement';

/**
 * Whether the tenant may use the access management / digital lock add-on
 * (Decision 2), layered on top of the check-in/check-out flow. Thin wrapper over
 * the shared entitlement resolver; the literal env read stays here so CRA
 * inlines it. Do NOT hardcode `true`.
 */
export function useCanUseAccessManagement(): boolean {
    return useEntitlement(
        'accessManagement',
        process.env.REACT_APP_FORCE_ACCESS_MGMT === 'true',
    );
}

/**
 * The same entitlement with its resolving state, for the route guard. The
 * boolean above cannot tell "not entitled" from "not answered yet", and the
 * access-management route redirects with `replace` — so it must wait here
 * rather than send a paying tenant to the upsell page (ADR-0001 Amendment 4).
 */
export function useAccessManagementEntitlement(): EntitlementState {
    return useEntitlementState(
        'accessManagement',
        process.env.REACT_APP_FORCE_ACCESS_MGMT === 'true',
    );
}
